import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useUnmount } from 'react-use';

import { type PublicBoard } from '@air/api/types';

import { getSavedSortFieldFromViews } from '~/components/v2/components/showcase/getSavedSortFieldFromViews';
import { resetCentralizedBoardAction } from '~/store/centralizedBoard/actions';
import { setSortingFieldAction } from '~/store/configViews/actions';
import { currentViewTypeNameSelector } from '~/store/configViews/selectors';

export type UsePublicShowcaseBoardSavedSortParams = {
  board: PublicBoard | undefined;
};

export const usePublicShowcaseBoardSavedSort = ({ board }: UsePublicShowcaseBoardSavedSortParams) => {
  const dispatch = useDispatch();
  const currentViewTypeName = useSelector(currentViewTypeNameSelector);

  useEffect(() => {
    if (!board?.id || !currentViewTypeName) {
      return;
    }

    const savedSort = getSavedSortFieldFromViews({
      views: board.views,
      viewTypeName: currentViewTypeName,
    });

    if (!savedSort?.name) {
      return;
    }

    dispatch(setSortingFieldAction({ sortingFieldName: savedSort.name, direction: savedSort.direction }));
  }, [board?.id, board?.views, currentViewTypeName, dispatch]);

  useUnmount(() => {
    // ViewSortingMenu gates Custom Sort on centralizedBoardExistsSelector; clear it so collection home cannot keep custom sort.
    dispatch(resetCentralizedBoardAction());
  });
};
